<!--
  File name: DataBreachTable.vue
  Program Description:
    - This component renders the tabs containing the list of all Data Breach
      Notifications

  Includes:
    - CrudTable: used to fetch the list of causes and renders it to a list table
    - Method to trigger the function to populate the list table
    - Mixin to containg all the functions for checking privileges
-->
<template>
  <v-container flex>
    <CrudTableExpand
      ref="crudTable"
      v-bind="{
        meta
      }"
    />
  </v-container>
</template>

<script>
import { privilegeMixin } from 'session-plugin'
import table from '@/meta/mdTable/crudModules/dataBreach/table'

export default {
  name: 'DbnStatusTable',
  mixins: [
    privilegeMixin
  ],
  data: () => ({}),
  computed: {
    meta () {
      return table
    }
  },
  methods: {
    async populateTable () {
      await this.$refs.crudTable.populateTable()
    }
  }
}
</script>
